(function () {
  var priceSelector = [
    '.product-single__price',
    '.js-product-price',
    '.js-product-compare-price',
    '.product-price',
    '.product-unit-price',
    '[data-price-container]'
  ].join(',');

  function formatAmount(value) {
    var amount = value.replace(/,/g, '');
    var number = Number.parseFloat(amount);

    if (!Number.isFinite(number)) {
      return value;
    }

    return Math.round(number).toLocaleString('en-IN');
  }

  function normalizePriceText(value) {
    return value
      .replace(/\brs\.?\s*([0-9][0-9,]*(?:\.\d+)?)/gi, function (_match, amount) {
        return '₹ ' + formatAmount(amount);
      })
      .replace(/₹\.\s*([0-9][0-9,]*(?:\.\d+)?)/g, function (_match, amount) {
        return '₹ ' + formatAmount(amount);
      })
      .replace(/(₹\s[0-9,]+)\.00\b/g, '$1');
  }

  function normalizeNode(node) {
    var nextValue;

    if (!node || node.nodeType !== Node.TEXT_NODE || !/(?:\brs\.?\s*[0-9]|₹\.\s*[0-9]|₹\s[0-9,]+\.00\b)/i.test(node.nodeValue)) {
      return;
    }

    nextValue = normalizePriceText(node.nodeValue);

    if (nextValue !== node.nodeValue) {
      node.nodeValue = nextValue;
    }
  }

  function normalizePrices(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var elements = [];

    if (scope.matches && scope.matches(priceSelector)) {
      elements.push(scope);
    }

    elements = elements.concat(Array.prototype.slice.call(scope.querySelectorAll(priceSelector)));

    elements.forEach(function (element) {
      Array.prototype.slice.call(element.childNodes).forEach(normalizeNode);
    });
  }

  function init() {
    normalizePrices(document);

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData') {
          normalizeNode(mutation.target);
          return;
        }

        Array.prototype.slice.call(mutation.addedNodes).forEach(function (node) {
          if (node.nodeType === Node.TEXT_NODE) {
            normalizeNode(node);
          } else if (node.nodeType === Node.ELEMENT_NODE) {
            normalizePrices(node);
          }
        });
      });
    });

    observer.observe(document.body, {
      childList: true,
      characterData: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
